module.exports = __webpack_public_path__ + "files/de8150cb85b13550712e8506096af316.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/skintone-19.png
// module id = 1508
// module chunks = 60